import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    AddressFieldDisplayCollectionModel,
    BillToModel,
    CountryModel,
    ShipToModel,
} from "@insite/client-framework/Types/ApiModels";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";
import ADIAddressInfoDisplay, { ADIAddressInfoDisplayStyles } from "@NA/Components/ADIAddressInfoDisplay";
import { cloneDeep } from "lodash";

interface OwnProps {
    address: ShipToModel;
    onChange: (address: BillToModel, isEdit:boolean) => void;
    countries: CountryModel[];
    addressFieldDisplayCollection: AddressFieldDisplayCollectionModel;
    extendedStyles?: ADIBillingAddressStyles;
    billToObj?: any;
    cartType?: string;
}

const mapStateToProps = (state: ApplicationState) => {
    const { cartId } = state.pages.checkoutShipping;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    return {
        cart: cartState.value,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasToasterContext;

export interface ADIBillingAddressStyles {
    container?: GridContainerProps;
    addressDisplayAndFormGridItem?: GridItemProps;
    addressDisplay?: ADIAddressInfoDisplayStyles;
}

export const adiBillingAddressStyles: ADIBillingAddressStyles = {
    container: { gap: 20 },
    addressDisplayAndFormGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
            padding-top: 0px;
        `,
    },
};

const ADIBillingAddress = ({ address, extendedStyles, billToObj, cartType }: Props) => {
    const styles = mergeToNew(adiBillingAddressStyles, extendedStyles);
    const primaryShipTo: ShipToModel = billToObj?.filter((s: any) => s.properties.isdropship === "False")[0];

    const [localAddress, setLocalAddress] = useState<ShipToModel | null>(null);
    useEffect(() => {
        if (cartType === "Quote") {
            const primaryShipToLocal = cloneDeep(primaryShipTo);
            if (primaryShipToLocal) {
                // keep this condition to assign a value in future
            }
            setLocalAddress(address);
        } else {
            setLocalAddress(address);
        }
    }, [cartType]);
    if (!localAddress) {
        return null;
    }
    return (
        <>
            <GridContainer {...styles.container}>
                <GridItem {...styles.addressDisplayAndFormGridItem}>
                    <ADIAddressInfoDisplay
                        {...localAddress}
                        state={localAddress.state?.abbreviation}
                        country={localAddress.country?.abbreviation}
                        extendedStyles={styles.addressDisplay}
                    />
                </GridItem>
            </GridContainer>
        </>
    );
};

export default connect(mapStateToProps)(withToaster(ADIBillingAddress));
